import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "./AuthProvider";
import { isAdminAccount } from "./roles";

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth();

  if (isLoading) return null;
  if (!user || !isAdminAccount(user.account_type)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
